export default __webpack_public_path__ + "static/customer-eac28db2f239d4f9e413aeede3e992d8.png";